import React, { useState } from 'react'

import IconButton from '../../elements/IconButton'
import TextInput from '../../elements/TextInput'
import Button from '../../elements/Button'

const Main = (props) => {

    const [paidNotes, setPaidNotes] = useState(props.existingNotes.paidNotes === null ? '':props.existingNotes.paidNotes)
    const [BMTNotes, setBMTNotes] = useState(props.existingNotes.BMTNotes === null ? '':props.existingNotes.BMTNotes)
    const [bonusesNotes, setBonusesNotes] = useState(props.existingNotes.bonusesNotes === null ? '':props.existingNotes.bonusesNotes)

    console.log(props)

    return (
        <div style={{width: '500px', height: 'auto', display: 'flex', flexDirection: 'column'}}>
            <div style={{flexBasis: '10%', display: 'flex', flexDirection: 'row'}}>
                <span style={{fontWeight: '500', fontSize: '20px', flexBasis: '99%'}}>Edit Week Notes</span>
                <IconButton img={false} colors={props.colors} Style={{borderRadius: '3px', backgroundColor: props.colors.border, width: '24px'}} size="16px">
                    <div onClick={props.setIsOpen} style={{paddingLeft: '3px', paddingRight: '3px'}}><span onClick={props.setIsOpen}>x</span></div>
                </IconButton>
            </div>
            <div style={{flexBasis: '90%', display: 'flex', flexDirection: 'column'}}>
                <div style={{marginTop: '10px'}}>
                    <span>Paid Notes: </span>
                    <TextInput
                        colors={props.colors}
                        data={paidNotes}
                        onChange={(value) => setPaidNotes(value)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault()
                                props.editWeekNotes(props.selectedWeekNum, paidNotes, BMTNotes, bonusesNotes)
                            }
                        }}
                        Style={{marginTop: '10px', width: '100%'}}
                    ></TextInput>
                </div>
                <div style={{marginTop: '10px'}}>
                    <span>BMT Notes: </span>
                    <TextInput
                        colors={props.colors}
                        data={BMTNotes}
                        onChange={(value) => setBMTNotes(value)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault()
                                props.editWeekNotes(props.selectedWeekNum, paidNotes, BMTNotes, bonusesNotes)
                            }
                        }}
                        Style={{marginTop: '10px', width: '100%'}}
                    ></TextInput>
                </div>
                <div style={{marginTop: '10px'}}>
                    <span>Bonuses Notes: </span>
                    <TextInput
                        colors={props.colors}
                        data={bonusesNotes}
                        onChange={(value) => setBonusesNotes(value)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault()
                                props.editWeekNotes(props.selectedWeekNum, paidNotes, BMTNotes, bonusesNotes)
                            }
                        }}
                        Style={{marginTop: '10px', width: '100%'}}
                    ></TextInput>
                </div>
                <Button colors={props.colors} onClick={() => props.editWeekNotes(props.selectedWeekNum, paidNotes, BMTNotes, bonusesNotes)} Style={{backgroundColor: props.colors.primary, color: props.colors.fontInvert, marginTop: '15px'}}>Save</Button>
            </div>
        </div>
    )
}

export default Main
